const zh = {
  base: {
    producer: '主板商',
    factory: '厂家',
    dealer: '经销商',
    customer:'客户',
    name: '名称',
    admin: '管理员',
    username: '用户名',
    password: '密码',
    password2: '密码确认',
    oldPassword: '原密码',
    newPassword: '新密码',
    email: '电子邮箱',
    title: '智慧运维平台',
    systemError: '系统错误，请联系相关人员查看',
    noSession: '无登录信息，请重新登录',
    noParam: '请填写正确的参数',
    index: '首页',
    columnIndex: '序号',
    info: '提示',
    confirm: '确定',
    cancel: '取消',
    search: '查询',
    edit: '修改',
    new: '新增',
    del: '删除',
    save: '保存',
    success: '成功',
    fail: '失败',
    refreshSuccess: '刷新成功',
    saveSuccess: '保存成功',
    bindSuccess: '绑定成功',
    unbindSuccess: '解绑成功',
    delSuccess: '删除成功',
    editFail: '修改失败',
    beginTime: '开始时间',
    endTime: '结束时间',
    beginDate: '开始日期',
    endDate: '结束日期',
    opt: '操作',
    power: '开关',
    on: '开启',
    pause: '暂停',
    off: '关闭',
    clear:'清屏',
    enabled: '启用',
    disabled:'禁用',
    reboot: '重启',
    refresh: '刷新',
    detail: '详情',
    choose: '请选择',
    online: '在线',
    offline: '离线',
    unknow: '未知',
    none: '无',
    city: '城市',
    model: '型号',
    date: '日期',
    month: '月',
    searchError: '查询失败',
    to: '至',
    timeInterval: '时间区间',
    requireTimeInterval: '请输入查询时间范围',
    outerTemp: '室外温度',
    outerHumid: '室外湿度',
    export: '导出',
    reset: '复位',
    update: '升级',
    second: '秒',
    minute: '分',
    minutes: '分',
    hour: '小时',
    number: '数量',
    rank: '排名',
    mobile: '手机号',
    level: '等级',
    compare: '对比',
    createdtime: '创建时间',
    plantime: '预约时间',
    runtime: '运行时间',
    uploadTime: '上传时间',
    uploadFile: '上传文件',
    upload: '上传',
    download: '下载',
    import: '导入',
    selectImportFile: '选择导入文件',
    tempDownload: '模版下载',
    status: '状态',
    finish: '完成',
    process: '进行中',
    startImport: '开始导入',
    errorDesc: '错误说明',
    summary: '统计',
    rate: '占比',
    remark: '备注',
    back: '返回',
    known: '知道了',
    floor: '楼层',
    room: '房间',
    sunday: '周日',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    yesterday: '昨天',
    today: '今天',
    clock: '点',
    total: '共',
    tai: '台',
    ge: '个',
    and: '并且',
    or: '或者',
    baseInfo: '基本信息',
    greater: '大于',
    less: '小于',
    equal: '等于',
    notequal:'不等于',
    cfgver:'版本号',
    collection:'收藏',
    group:'分组',
    tag:'标签',
    newtag:'新标签',
    image:'图片',
    view:'查看'
  },
  login: {
    username: '请输入用户名',
    password: '请输入密码',
    type: '类型',
    producer: '主板商',
    factory: '厂家',
    dealer: '经销商',
    login: '登录',
    requireMessage: '请输入用户名与密码',
    noPermission: '无平台权限',
    passwordError: '用户名或密码错误'
  },
  index: {
    logoff: '登出',
    personSet: '个人设置',
    changePassword: '修改登录密码',
    resetPassword: '重设密码',
    dashboard: '大屏展示',
    overview: '数据总览',
    customer: '客户管理',
    customerList: '客户列表',
    feedback: '客户反馈',
    device: '设备管理',
    deviceNo: '机组列表',
    deviceEdit: '机组维护',
    gatewayList: '网关列表',
    gatewayUpdate: '网关升级',
    deviceList: '设备列表',
    deviceCamp: '设备比较',
    gatewayDetail: '设备详情',
    firmwareUpdate: '固件升级',
    batchUpdate: '批量升级',
    deliver: '网关划拨',
    errorList: '当前故障列表',
    errorDetail: '故障设备列表',
    firmware: '固件管理',
    import: '绑定关系导入',
    SIM: 'SIM卡管理',
    simList: 'SIM卡列表',
    log: '日志记录',
    optHistory: '操作日志',
    errHistory: '故障日志',
    errTime: '故障定时推送',
    dealer: '经销商管理',
    dealerList: '经销商列表',
    newDealer: '新建经销商',
    editDealer: '编辑经销商',
    factory: '厂家管理',
    factoryList: '厂家列表',
    Fee: '费用与发票',
    recharge: '账户充值',
    rechargeHistory: '账户详情',
    setup: '系统设置',
    systemParam: '系统参数',
    staff: '职员管理',
    staffList: '职员列表',
    role: '角色管理',
    roleList: '角色列表',
    newRole: '新增角色',
    editRole: '编辑角色',
    setupPermission: '权限分配',
    warningRole: '设备预警规则',
    warningRoleEdit: '规则配置',
    warningDevice:'预警设备',
    dealerRoleList:'经销商参数权限',
    newDealerRole:'新增权限',
    editDealerRole: '编辑权限',
    protocolSetup:'设备协议',
    editStaff:'职员修改',
    newStaff:'新增职员',
    SMS:'短信记录',
    SMSRecharge:'短信充值',
    Document:'文档资料',
    DocumentGroup:'文档分组',
    CreateDocument:'文档维护',
    Mind:'故障导图',
    MindList:'故障处理流程列表'
  },
  welcome: {
    welcome: '欢迎使用'
  },
  notFound: {
    notFound: '欢迎使用智慧运维平台'
  },
  device: {
    newProjectName: '请输入新的项目名',
    newProjectAddress:'请输入新的项目地址',
    gatewayNo: '网关编号',
    gatewayOnline: '4G状态',
    flowLeft: '4G剩余流量（MB）',
    simExpireTime: '4G到期时间',
    protocol: '设备协议',
    batchSetup: '批量设置',
    batchSetupSuccess: '批量设置成功',
    firmwareVersion: '固件版本',
    newVersion: '新的固件版本可升级',
    updating: '升级中',
    simSet: '4G套餐',
    set: '套餐',
    flowused: '已用',
    reset: '剩余',
    lnglat: '经纬度定位',
    rate: '网关信号',
    gatewayLnglat: '网关定位',
    addressInfo: '地址信息',
    chooseOneGeteway: '请选择需要设置的的网关',
    chooseOneDealer: '请选择需要分配的经销商',
    updateTips: '升级过程大约需要30秒，升级结束后需要手动刷新列表展示新的版本号',
    gatewayUpdate: '网关固件升级',
    gatewayUpdateFail: '固件升级失败',
    firmwareUpdate: '固件升级',
    deliveDealer: '分配经销商',
    autoReset: '故障自动复位',
    autoResetTip: '开启自动复位后，当发生故障时将自动在设置时间内发送2次复位指令',
    autoResetTime: '自动复位时间',
    autoResetTimeTip: '修改时间后会自动开启自动复位功能',
    deviceSummary: '设备概述',
    webOff: '网页连接中断',
    offLineAlert: '注意！当前网关离线，所有数据为最后在线缓存数据，非实时！',
    projectName: '项目名',
    address: '地址',
    customerPhone: '业主电话',
    srcaddress: '通讯码',
    deviceNo: '机组编号',
    deviceError: '设备故障',
    deviceOnline: '设备状态',
    tab_setupParam: '设置参数',
    tab_runParam: '运行参数',
    tab_elec: '能耗分析',
    tab_report: '参数曲线',
    tab_historyError: '历史故障',
    tab_optLog: '控制记录',
    tab_customer: '用户管理',
    tab_mibee: '4G网关',
    tab_timing: '定时设置',
    tab_flow: '流量分析',
    tab_update: '升级日志',
    saveFlowTip: '您已10分钟未操作页面，为节省4G网关流量，系统已断开连接，按F5刷新即可恢复连接。',
    changeSort: '调整排序',
    noSupportReset: '该设备不支持复位操作',
    yesterdayPowerused: '昨日能耗',
    todayPowerused: '今日能耗',
    currentA: '当前电流',
    currentW: '当前功率',
    powerused: '能耗',
    noAcbData: '项目中还没有能耗分析的数据。',
    noErrorData: '设备暂无故障记录。',
    noOptLog: '该设备暂无操作记录。',
    noCustData: '暂无用户绑定该网关',
    noOfflineData: '15天内无在线变动记录',
    heatpumpSelect: '设备选择',
    paramSelect: '参数选择',
    showType: '展示方式',
    showToge: '合并展示',
    showSingl: '单独展示',
    deviceName: '设备名称',
    errorDetail: '故障详情',
    errorMsg: '故障内容',
    errorTime: '故障时间',
    resetTime: '复位时间',
    optParam: '操作参数',
    changeValue: '变动值',
    desc: '说明',
    optTime: '操作时间',
    optBy: '操作人',
    buildQrcode: '生成绑定二维码',
    bindTime: '绑定时间',
    unbindTime: '解绑时间',
    mainAccount: '主帐号',
    subAccount: '子帐号',
    unbind: '解绑',
    custBindQrcode: '用户绑定二维码',
    Valid10Mins: '有效时间已后台设置为准',
    UnbindCustConfirm: '确定解绑账户',
    updatedVersion: '升级版本',
    unknowVersion: '未知版本',
    updateTime: '升级时间',
    result: '结果',
    notStartVersionUpdate: '未开始升级',
    updateVersionSuccess: '升级成功',
    noNeedUpdateVserion: '已是最新，无需升级',
    updateVersionOffline: '升级失败，设备离线',
    updateVersionFial: '升级失败',
    updateVersionUnkonow: '结果未知',
    changeProtocol: '协议变更',
    heatpumpVersionUpdate: '设备固件升级',
    rebootGateway: '重启网关',
    updateInBackGround: '后台升级中',
    gatewayNoNeedUpdate: '最新版本或网关不在线',
    reportInterval: '数据采集间隔',
    reportTime: '数据采集时间',
    gatewayLog: '网关离线记录',
    updatedTime: '变更日期',
    selectOneVersion: '请先选择一个固件版本',
    refreshWebAfterUpdate: '固件升级完成，刷新页面获取新版本号',
    chooseProtocol: '请选择变更的协议',
    noProtocolChange: '协议无变化，无需变更',
    changeProtocolConfirm: '变更协议，服务器数据将被初始化，确认继续？',
    bindDealer: '绑定经销商',
    bindGateway: '绑定网关',
    requireDeviceNo: '请输入编号',
    requireDealer: '请选择经销商',
    requireGateway: '请选择网关',
    sofewareVersion: '软件版本',
    paramCompareList: '参数对比列表',
    max5Compare: '最多同时选择5个网关进行比较',
    alreadyCompare: '已在比对列表中',
    differentProtoComp: '不支持跨协议对比',
    choose25Compare: '请选择2-5个设备进行比对',
    timingHistory: '定时历史记录',
    noDeviceCanBeUpdated: '暂无可升级的设备，请确定设备已接入互联网。',
    currentVersion: '当前版本',
    updateProcess: '升级进度',
    chooseOneVersion: '选择固件版本',
    updateChoosen: '升级选中项',
    createTiming: '创建为定时任务',
    bookTime: '预约时间',
    schUpdateTime: '计划升级时间',
    bookRecord: '预约记录（最近30天）',
    bookDeviceNumber: '预约设备数',
    selectOneDevice: '请先选择设备',
    deviceNotMatchVersion: '设备软件版本与固件版本不符，请核对',
    resetSucessInfo: '复位指令发送成功，2秒后重新查询故障列表',
    firmwareName: '固件版本名',
    firmwareVersionNumber: '固件版本号',
    deviceVersion: '设备程序版本号',
    selectOneFirmwareFile: '选择一个固件文件',
    uploadTime: '上传时间',
    selectOneProtocol: '请选择相关协议',
    requireFirmwareName: '请输入版本名',
    requirefirmwareVersionNumber: '请输入版本号',
    requirefirmwareVersionNumberInt: '版本号必须为数字值',
    delFirmware: '确定删除固件',
    delRule: '确定删除规则',
    errorDay: '故障日期',
    ruleList: '规则列表',
    ruleRelationship: '规则关系',
    ruleRequired:'至少添加一条规则',
    ruleDpRequired:'请选择参数',
    ruleValueRequired:'请输入值',
    cdp:'对比参数',
    noPeople:'无人值守',
    noPeopleing:'无人值守中',
    nopeopleTip:'开启后请在对应的预警规则中同时启用无人值守功能',
    errorAlert:'故障短信通知',
    ruleTimeMin:'持续时间（分）',
    ruleTip1:'如选择“对比参数”,则规则公式为: (控制点-对比参数) >，<，= (值)',
    ruleTip2:'持续时间设置为0，表示不考虑持续时间',
    noPeopleRole:'无人值守规则',
    noPeopleRole1:'开启无人值守时，对应的网关也需要同步开启无人值守模式才可生效工作',
    noPeopleRole2:'当无人值守网关匹配预警规则将自动发送下方配置的指令',
    noPeopleRole3:'无人值守网关不会进行故障报警推送',
    reportTips:'网关分配约30MB的存储空间，存储频率与时长关系仅供参考',
    reportTips5:'5秒：数据保存约1.5天',
    reportTips10:'10秒：数据保存约3天',
    reportTips60:'1分钟：数据保存约18天',
    reportTips1800:'30分钟：数据保存约500天',
    reportTipsmibee:'设置10分钟以下，网关会进入数据实时投递模式，注意流量使用。',
    noGounp:'未分组参数',
    confirmDeleteError:'确认删除此条故障',
    newModel:'新的型号',
    displayRule:'显示规则',
    displayProtocol:'协议控制',
    displayShow:'强制显示',
    displayHide:'强制隐藏',
    displayConfig:'设备展示配置',
    debugger:'设备调试',
    debugInfo:'功能消耗大量流量，使用结束请及时暂停或关闭'
  },
  overview: {
    custNumber: '用户数量',
    equipNumber: '网关入库数量',
    deviceNumber: '设备入网数量',
    onOffRate: '在线离线比',
    dealerNumber: '经销商数量',
    feedbackNumber: '未处理用户反馈',
    simNumber: 'SIM卡即将到期',
    error30Number: '30日故障量',
    error: '故障',
    errnNumber: '故障次数',
    custGrowReport: '用户增长曲线',
    equipGrowReport: '入网网关曲线',
    modelReport: '机组型号统计',
    error30type: '30日内高发故障',
    error30equip: '30日内故障机组排行'
  },
  customer: {
    avatar:'头像',
    nickname: '昵称',
    bindGateWay: '绑定4G模块编号',
    createdtime: '注册时间'
  },
  sim: {
    simPoolInfo: '流量池信息',
    poolUserdMonth: '当月流量池已使用',
    set: '套餐',
    poolSet: '流量池套餐',
    totalFlow: '总流量',
    usedFlow: '已用流量',
    resetFlow: '剩余流量',
    simNumber: 'SIM卡总数',
    simActiveNumber: '已激活',
    simUnit: '张',
    carrier: '运营商',
    cardStatus: '卡状态',
    startdate: '激活日期',
    expiredate: '过期日期',
    updatedtime: '更新时间',
    active: '强制激活',
    activeSuccess: '激活成功，卡状态需等待运营商同步',
    activeFail: '激活失败',
    recharge: '续费',
    planRecharge: '套餐续费',
    rechargeIccid: '续费ICCID',
    total: '共',
    planName: '套餐名称',
    planFlow: '套餐流量',
    price: '单份价格',
    rechargeUnit: '套餐周期',
    rechargeNumber: '续费份数',
    amount: '支付总额',
    noIccid: '无ICCID信息',
    noSetInfo: '无可续费套餐信息',
    differenrSet: '选中SIM卡套餐不一致',
    requireSims: '请选择需要充值的SIM卡',
    noRechargeInfo: '续费信息不完整'
  },
  fee: {
    totalAmount: '累计充值金额',
    totalnumber: '累计充值笔数',
    resetAmount: '当前可用余额',
    canInvoice: '可开票金额',
    yuan: '元',
    bi: '笔',
    rechargeHistory: '充值记录',
    orderNo: '订单号',
    orderAmount: '充值金额',
    orderTime: '订单日期',
    recharge: '充值',
    pay: '支付',
    paySuccess: '支付成功',
    weChatPay: '微信扫码支付',
    createdBy: '创建人',
    finistTime: '支付完成时间',
    status: '状态',
    customAmount: '自定义金额',
    paymentType: '付款方式',
    clickBack: '请点击返回',
    wechat: '微信支付',
    qrcodePay: '支付二维码',
    requirePaymentAmount: '请输入正确的充值金额和付款方式'
  },
  setup: {
    baseInfo: '基础信息',
    dealerHide: '经销商参数隐藏(全局)',
    custHide: 'C端高级参数展示(全局)',
    errorLevel: '故障推送等级',
    payment:'付款定价',
    step1: '步骤1：选择设备类型',
    step2: '步骤2：勾选需要隐藏的参数',
    step2Error: '步骤2：选择推送等级',
    checkHideControlParam: '勾选隐藏的控制参数',
    checkHideRunParam: '勾选隐藏的运行参数',
    cityTip: '将用于大屏展示室外天气，仅填写城市名称即可，如"杭州"',
    platformName: '平台抬头名称',
    companyDesc: '公司简介',
    person: '联系人',
    companyShort: '公司简称',
    isSMS: '接受报警短信',
    phone: '热线电话',
    phoneTip: '会展示在下级经销商设备报警短信中',
    email: '通知邮箱',
    emailTip: '如有邮件相关业务会投送至此邮箱，多个邮箱请用“,”分隔',
    requireName: '请输入名称',
    sizeLimit: '上传图片大小不能超过 2MB!',
    setupPermission: '设置权限',
    confirmDeletePermission: '确定删除权限',
    confirmDeleteStaff: '确定删除职员',
    role: '权限组',
    typeNewPassword: '请输入新密码',
    usernameCheck: '用户名中不能包含@',
    mobileCheck: '请输入正确的手机号',
    passwordCheck: '密码不能小于6位',
    password2Check: '两次输入密码不一致!',
    requireRole: '请选择权限',
    requireUsername: '请输入用户名',
    requireSMScode: '请输入验证码',
    requirePassword: '请输入密码',
    requireOldPassword: '请输入原密码',
    requireNewPassword: '请输入新密码',
    requirePassword2: '请输入确认密码',
    staffPermissionTip: '添加权限后，此职员将仅可访问有权限的网关设备。未单独添加权限的账户，默认可访问全设备。',
    dealerPermission: '划拨经销商权限',
    addPermission: '添加权限',
    gatewayPermission: '单独网关权限',
    requireDealer: '请先选择要绑定的经销商或网关编号',
    duplictPermission: '重复添加了相同的权限过滤',
    confirmDelete: '确定删除？',
    platformName_en:'英文抬头',
    allHide:'全部隐藏',
    allShow:'全部展示',
    cbind:'C端二维码有效期'
  },
  dealer: {
    name: '经销商名称',
    parent: '上级经销商',
    mainAccount: '主账户名',
    level: '级别',
    phone: '联系电话',
    factoryPhone: '厂家热线',
    short: '简称',
    confirmDeleteAccount: '确定删除账户',
    cityTip: '仅填写城市名称，如“杭州”',
    invalidUsername: '非法用户名',
    requireName: '请输入名称',
    confirmUnbindGateway: '确定解绑网关',
    bindGateway: '网关绑定',
    permissionSet: '权限设置',
    basePermission: '基本权限',
    allowWeb: '允许登录平台',
    allowMiniprogram: '允许登录小程序',
    allowChild: '允许创建下级经销商',
    equipment: '所属设备',
    baseInfo: '基本信息',
    reset: '设备复位',
    role:'经销商参数权限',
    errorPush:'故障推送',
    errorhide:'平台故障隐藏'
  },
  timing: {
    name: '定时名称',
    add: '添加定时',
    addDeivce: '添加设备',
    repeat: '重复',
    chooseRepeat: '请选择是否重复',
    runOnce: '只工作一次',
    runRepeat: '重复执行',
    runDevice: '执行设备',
    runTime: '执行时间',
    chooseRunTime: '选择执行时间',
    dateRanger: '日期约束',
    timeRanger: '时间约束',
    dateFilter: '日期过滤',
    timeTip: '如填写了“结束时间”，则在到达结束时间点，设备会还原成定时开始前的状态。',
    conditionTip: '除了“自定义”选项外，其他条件为“并且”关系，如同时选择了“法定工作日”与“法定节假日”，则这个定时永远不会触发。',
    dp: '控制点',
    value: '值',
    setValue: '设定值',
    chooseDp: '请选择操作',
    runtimeCheck: '请输入一次性运行时间',
    begindateCheck: '请输入重复运行开始日期',
    begintimeCheck: '请输入重复运行开始时间',
    deviceCheck: '请正确设置设备参数',
    new: '新增定时',
    edit: '修改定时',
    confirmWill: '确定删除',
    allweek: '周一至周五',
    work: '法定工作日',
    holiday: '法定节假日',
    cust: '自定义',
    triggerTime: '触发时间',
    requireName:'请输入定时名称',
    requireType:'请选择定时类型',
    atLeastOneDevice:'请至少选择一个设备'
  },
  report:{
    exit:'退出大屏',
    projectList:'全国项目列表',
    projectNumber:'累计项目数量',
    deviceNumber:'累计设备数量',
    modelNumber:'设备型号数量统计',
    runStatus:'设备运行情况统计',
    p5top:'设备省份分布排行前五名'
  },
  document:{
    newGroup:'新建分组',
    newLevel:'新建下级分类',
    newGroupName:'新的分组名',
    confirmDeleteGroup:'确认删除分组',
    confirmDeleteDocument:'确认删除文档',
    pdfview:'PDF文档查看',
    outurl:'外部资源',
    name:'文档名称',
    pdf:'PDF文件',
    thirdurl:'第三方视频网站URL',
    delPdf:'删除已有PDF文件',
    requireName:'请输入名称',
    requireGroup:'请选择分组',
    requireNode:'请先选择一个节点',
    newNodeName:'新的节点名',
    confirmDeleteNode:'确认删除节点',
  }

}

export default zh



// WEBPACK FOOTER //
// ./src/i18n/zh.js